import React from 'react';
import { TextField, useRecordContext } from 'react-admin';
import { get, isEmpty } from 'lodash';
import { Typography } from '@mui/material';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import getCoefficientFromPeriod from '../../../../utilities/getCoefficiantFromPeriod';
import questionElementTypes from '../../../../constants/questionElementTypes';
import { SourceOfWealthAmountParameters } from '../../questionParameters';

const VALUE_LABEL = {
  [languages.SV]: 'Brutto månadsinkomst från angiven förmögenhetskälla',
  [languages.EN]: 'Gross monthly income of provided source of wealth',
  [languages.DE]: 'Brutto-Monatseinkommen aus der angegebenen Vermögensquelle',
};

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: SourceOfWealthAmountParameters;
  language?: Languages;
}) => {
  const record = useRecordContext();

  const valueObj = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (isEmpty(valueObj)) return <Typography>-</Typography>;

  let value = '';
  const defaultValue = `${valueObj.value * getCoefficientFromPeriod(extraParameters?.unit, extraParameters?.period)} ${valueObj.currency}`;
  if (extraParameters?.type === questionElementTypes.SELECT && extraParameters?.options) {
    const option = extraParameters.options.find(({ id }) => id === valueObj.value);
    value = option
      ? extraParameters.choiceLabels?.[String(option.id)] ?? option.label
      : defaultValue;
  } else {
    value = defaultValue;
  }

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const SourceOfWealthAmount = ({ extraParameters }: {
  extraParameters?: SourceOfWealthAmountParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? VALUE_LABEL[language]}
      source="sourceOfWealthAmount"
      datapoint={conflictFields.INCOME}
      identificationInfo={undefined}
    >
      <ValueField extraParameters={extraParameters} />
    </Answer>

  );
};

SourceOfWealthAmount.ValueField = ValueField;

export default SourceOfWealthAmount;
